<template>
  <div>
    <div class="sub-title mt-[28px]"
         ref="refMap">
      {{ $t('space.map') }}
    </div>
    <div id="infomap"
         class="w-full h-[270px] mt-[10px] map"></div>
  </div>
</template>
<script setup
        lang="ts">
import {reactive, toRaw} from "vue";

const locationModelValue = defineModel('spaceLocation', {type: Object, default: () => ({})});
const states = reactive({
  google: null,
  map: null,
  marker: null
});

onMounted(async () => {
  await initMap();
});


const initMap = async () => {
  try {
    const { $loadGoogleMaps } = useNuxtApp();
    const googleMaps = await ($loadGoogleMaps as () => Promise<any>)();
    const { Map } = await googleMaps.importLibrary('maps');
    const { AdvancedMarkerElement } = await googleMaps.importLibrary("marker");

    const mapOptions = {
      mapId: 'DEMO_MAP_ID',
      center: {
        lat: locationModelValue.value.coordinates[1],
        lng: locationModelValue.value.coordinates[0]
      },
      zoom: 14,
      maxZoom: 18,
      minZoom: 10,
      streetViewControl: false,
      mapTypeControl: false,
      fullscreenControl: false,
      zoomControl: true
    };

    states.map = new Map(document.getElementById('infomap'), mapOptions);

    // 創建自定義 marker 元素
    const markerImage = document.createElement('img');
    markerImage.src = 'https://pic.onestep.place/images/location4.svg';
    markerImage.style.width = '26px';
    markerImage.style.height = '30px';

    states.marker = new AdvancedMarkerElement({
      map: toRaw(states.map),
      position: {
        lat: locationModelValue.value.coordinates[1],
        lng: locationModelValue.value.coordinates[0]
      },
      content: markerImage,
      zIndex: 1
    });

  } catch (error) {
    console.error('Google Maps 初始化失敗', error);
  }
};


defineExpose({initMap});

</script>
<style scoped
       lang="scss">
.map{
 z-index: 0!important;
}

.map :global(.gm-style) {
  z-index: 0; // 將所有 Google Maps 的元素 z-index 設為較低的值
}

.map :global(.gm-style div) {
  z-index: 0;
}


:deep(.gm-style) {
  z-index: 0!important;
}

:deep(.gm-style div) {
  z-index: 0!important;
}



</style>
